module.exports = __webpack_public_path__ + "static/img/gov.d0289dc0.png";